import { CheckIcon } from '@heroicons/react/20/solid';

import { DisplayComponent } from '@/components/DisplayComponent';
import { Header } from '@/components/Header';
import { OutcomeCard } from '@/components/OutcomeCard';
import { ProgressBar } from '@/components/ProgressBar';
import { RemoteImage } from '@/components/RemoteImage';
import { useAppSelector } from '@/context/storeHooks';
import { useCopy } from '@/copy';

import { ServicingSuccessButtons } from './ServicingSuccessButtons';

export const testId = 'screen-servicingSuccess';

export function ServicingSuccess(): JSX.Element {
    const baseId = 'screen-servicingSuccess';
    const { outcomes, successCard } = useCopy();
    const outcome = outcomes.servicingSuccess;
    const serviceabilityResult = useAppSelector(
        (state) => state.displayReducer.serviceabilityResult
    );
    const hasLenders = serviceabilityResult?.hasLenders ?? false; // Default to false for testing

    if (successCard) {
        return (
            <div data-testid={testId}>
                <DisplayComponent baseId={baseId}>
                    <Header />
                    <ProgressBar />
                    <OutcomeCard
                        icon={<CheckIcon className='h-6 w-6' />}
                        tint='bg-reassureBg text-reassureText'
                        title={outcome.title}
                        lines={outcome.body}
                    />
                    <ServicingSuccessButtons baseId={baseId} />
                </DisplayComponent>
            </div>
        );
    }

    return (
        <div data-testid={testId}>
            <DisplayComponent baseId={baseId}>
                <Header />
                <ProgressBar />
                <div className='flex-center pt-4 pb-10 relative'>
                    <div className='bg-primary h-40 w-40 rounded-full' />
                    <RemoteImage fileName='applause.svg' className='absolute' />
                </div>
                <div className='text-center _flex flex-col space-y-2'>
                    <h3 className='uppercase text-xl text-primary font-bold '>
                        {outcome.body.length > 0 ? (
                            outcome.title
                        ) : (
                            <>
                                Great News!
                                <br />
                                What&apos;s Next?
                            </>
                        )}
                    </h3>
                    {outcome.body.length > 0 ? (
                        outcome.body.map((line, i) => (
                            <p
                                key={line}
                                className={
                                    i === 0 ? 'text-secondary ' : 'text-sm'
                                }
                            >
                                {line}
                            </p>
                        ))
                    ) : hasLenders ? (
                        <>
                            <p className='text-secondary '>
                                We&apos;ve found some suitable <br />
                                lenders for your loan.
                            </p>
                            <p className='text-sm'>
                                Keep going to see your rates, choose
                                <br />
                                your lender and submit to them for <br /> final
                                approval.
                            </p>
                        </>
                    ) : (
                        <>
                            <p className='text-secondary '>
                                You meet the basic requirements <br />
                                for a loan.
                            </p>
                            <p className='text-sm'>
                                Keep going to see your rates and submit <br />
                                your application for final approval.
                            </p>
                        </>
                    )}
                </div>
                <ServicingSuccessButtons baseId={baseId} />
            </DisplayComponent>
        </div>
    );
}
